import { NgModule } from '@angular/core';
import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { NavbarComponent } from './navbar/navbar.component';
import { AboutModalComponent } from './navbar/about-modal.component';
import OktaModule from './shared/okta-auth.module';
import { HeaderInterceptor } from './core/interceptors/header-interceptor.service';
import { IdleUserSignOutModalComponent } from './idle-user/modal/idle-user-sign-out-modal.component';
import { BaseDatePipe } from './shared/pipes/base-date.pipe';
import { NgIdleModule } from '@ng-idle/core';
import { HttpInterceptorsModule } from './modules/data/data-entry/interceptors/http-interceptors.module';
import { ClockComponent } from './navbar/clock.component';
import { UserDetailModalComponent } from './navbar/user-detail-modal/user-detail-modal.component';
import { MarkdownModule } from 'ngx-markdown';

@NgModule({
    declarations: [
        AppComponent,
        NavbarComponent,
        ClockComponent,
        AboutModalComponent,
        IdleUserSignOutModalComponent,
        UserDetailModalComponent
    ],
    bootstrap: [AppComponent],
    imports: [
        AppRoutingModule,
        BrowserModule,
        BrowserAnimationsModule,
        HttpInterceptorsModule,
        OktaModule,
        SharedModule,
        NgIdleModule.forRoot(),
        MarkdownModule.forRoot()
    ],
    providers: [
        {
            provide: DatePipe,
            useClass: BaseDatePipe
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HeaderInterceptor,
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class AppModule {}
